// This assumes only one filter per key
export const toKey = (filter) => {
    return filter.id;
};
// Keep this lookup independent of the full generated FilterX union. Expanding
// that union for Array.find exceeds the compiler's complexity limit.
export const findUpdateTypeFilter = (filters) => {
    if (!Array.isArray(filters)) {
        return undefined;
    }
    return filters.find((filter) => filter.type === 'in' &&
        filter.property[0] === 'updates' &&
        filter.property[1] === 'updateTypeId');
};
//# sourceMappingURL=util.js.map